import {NavLink} from '@wandb/weave/common/util/links';
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {getNewNwUrlSearch, ParamNames} from '../../../state/workspaces/url';
import {
  NamedWorkspaceMenuItemContent,
  type NamedWorkspaceMenuItemProps,
} from './NamedWorkspaceMenuItem';
import {UserProfileImage} from './UserProfileImage';

export const LegacyNamedWorkspaceMenuItemComp = ({
  option,
}: NamedWorkspaceMenuItemProps) => {
  return (
    <NavLink
      className="flex grow text-wb-text-primary dark:text-moon-300"
      to={getNewNwUrlSearch({
        [ParamNames.nwId]: option.namedWorkspaceId.id,
      })}>
      {option.optionType === 'personal' ? (
        <UserProfileImage src={option.photoUrl} alt={option.displayName} />
      ) : (
        <div className="h-24 w-24">
          <Icon name="view-glasses" width={18} height={18} />
        </div>
      )}
      <NamedWorkspaceMenuItemContent option={option} showEditLock={false} />
    </NavLink>
  );
};
